module.exports = __webpack_public_path__ + "static/img/4.6379f6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/4.png
// module id = DUpJ
// module chunks = 0